<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card p-2 m-6 bg-default container">
                    <div class="row" v-if="lettersData.length<5">
                        <h5  class="col-5">Create/ Edit a Letter to Yourself (Max 5):</h5>
                        <button style="height:32px; max-width:100px;" class=" col-2 btn btn-sm btn-primary" @click="newLetterModal()">New Letter</button>
                    </div>
                    <div class="row mt-2 d-flex justify-content-center" v-if="lettersData.length>0">
                        <div class="col-md-3 content-left">
                            <select  style="width:20em;" class="form-control" :hidden="lettersData.length <1"
                                        @change="displaySelectedLetterx()" v-model="selectedLetterID">
                                <option value="">Select a Letter</option>
                                <option
                                    v-for="letter in lettersData"
                                    :key="letter.id"
                                    :value="letter.id"
                                >{{ letter.title }}</option>
                            </select>
                        </div>
                    </div>
                    <button style="width:200px;" :hidden="selectedLetterID==''" class="btn btn-sm btn-warning mx-auto mt-2" @click="editSelectedLetter()">Edit Letter</button>
                </div>
            </div>
            <futureselfletter :userdata="userdata" :apikey="apikey"></futureselfletter>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../../event-bus';
import futureselfletter from '../modal/FutureSelfLetter.vue';


export default {
    components:{
        futureselfletter,
     },
    name: "LettersEditor",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            userData:'',
            lettersData: '',
            selectedLetterID: '',
            selectedLetterData:'',
            fsLetterData:[],
      }
    },

    props: {
        userdata:'',
        letters:'',
        apikey:'',

    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.lettersData = JSON.parse(this.letters);
        //extract the fsLetters
        this.getFSLetterData();

        // EventBus.$on('refreshAfterLetterSave', (data)=>{
        //     location.reload();
        // });

    },

    methods: {
        getFormattedDate(dateString) {
            var theDate = new Date(dateString);
            return theDate.toISOString().split('T')[0];
            // letter.created_at.toISOString().split('T')[0]
        },
        getFSLetterData() {
               this.lettersData.forEach((letter)=>{
                    if(letter.direction){//letters with direction true are from FSelf to Me.
                        this.fsLetterData.push(letter);
                        console.log("Found letter FROM FutureSelf");
                    }
            });
        },
        displaySelectedLetterx() {
            this.selectLetter(this.selectedLetterID);
            // this.$emit('display-selected-letter', this.selectedLetterID);
            console.log("LetterEditor called displaySelectedLetter..............");
            const payload = {
                letter: this.selectedLetterData,
                user: this.userinfo,
                };
            EventBus.$emit('display-selected-letter', payload);
        },
        editSelectedLetter() {
            // console.log("editSelecteLetter triggered....");
            if(this.selectedLetterID) {
                this.showLetterModal(this.selectedLetterID);
            }
        },
        showLetterModal(letterid) {
            if(this.selectedLetterID) {
                this.selectLetter(letterid) ;
            // console.log("showLetterModal triggered...." + letterid);
            const payload = {
                letter: this.selectedLetterData,
                user: this.userinfo,
                };
              EventBus.$emit('displayLetterModal', payload);
            }
        },
        selectLetter(letterid) {
             [...this.lettersData].forEach((letter)=>{
                //  console.log(letter);
                if(letter.id == letterid) {
                    this.selectedLetterData = letter;
                    console.log("Found Selected Letter: " + this.selectedLetterData);
                }
            });
            // console.error(this.selectedLetterData);
        },

        newLetterModal() {
            // console.error('New Letter....');
            var payload = {user:this.userData};
            EventBus.$emit('newLetterModal', payload);
        },
    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
/* https://code.tutsplus.com/tutorials/create-a-sticky-note-effect-in-5-easy-steps-with-css3-and-html5--net-13934 */
@media only screen and (min-width: 768px) {
    h6 {
    font-family:  Kalam;/** 'Reenie Beanie'; */
    font-weight: bold;
    font-size: 2rem;
    }
    p {
    font-family: Kalam;/** 'Reenie Beanie'; */
    font-size: 2rem;
    }
    ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    }
    ul li a{
    text-decoration:none;
    color:#000;
    background:#ffc;
    display:block;
    /* height:42em; */
    width:25em;
    padding:1em;
    box-shadow: 5px 5px 7px rgba(33,33,33,.7);
    transition: transform .15s linear;
    }
    ul li{
    margin:1em;
    }
    ul li a{
    transform: rotate(-6deg);
    }
    ul li:nth-child(even) a{
    transform:rotate(4deg);
    position:relative;
    top:5px;
    background:#cfc;
    }
    ul li:nth-child(3n) a{
    transform:rotate(-3deg);
    position:relative;
    top:-5px;
    background:#ccf;
    }
    ul li:nth-child(5n) a{
    transform:rotate(5deg);
    position:relative;
    top:-10px;
    }
    ul li a:hover,ul li a:focus{
    box-shadow:10px 10px 7px rgba(0,0,0,.7);
    transform: scale(1.25);
    position:relative;
    z-index:5;
    }
}
@media only screen and (max-width: 768px) {
 ul li a{
    text-decoration:none;
    color:#000;
    background:#ffc;
    display:block;
    /* height:25em; */
    width:15em;
    text-align: left;
    padding:.5em;
    box-shadow: 5px 5px 7px rgba(33,33,33,.7);
    text-overflow: clip;

    }
}

</style>
